// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { initializeScrollTo } from "@mcmc/App/Libraries";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getSpecSheetLink } from "@mcmc/App/Store/Selectors/ProductDetailsSelectors";
import SpecSheet from "@mcmc/XDL/Icons/SpecSheet";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct;

const mapStateToProps = (state: McMcApplicationState, props: OwnProps) => ({
    specSheetLink: getSpecSheetLink(state, props.product),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsSpecSheetStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const specSheetStyles: ProductDetailsSpecSheetStyles = {
    wrapper: {
        css: css`
            margin: 20px 0;
        `,
    },
    link: {
        typographyProps: {
            size: 16,
        },
        icon: {
            iconProps: {
                src: SpecSheet,
                size: 20,
                css: css`
                    margin-right: 6px;
                `,
            },
        },
    },
};

const styles = specSheetStyles;

const ProductDetailsSpecSheet: React.FC<Props> = ({ specSheetLink }) => {
    if (!specSheetLink) {
        return null;
    }

    const moveToDocumentation = () => {
        document.getElementById("documents-tab")?.click();
        initializeScrollTo("[data-test-selector='productDetails_specifications']");
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link onClick={moveToDocumentation} {...styles.link}>
                {translate("Spec Sheet")}
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsSpecSheet)),
    definition: {
        displayName: "Spec Sheet Link",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
